import React from 'react';
import { InputText } from 'primereact/inputtext';
import { SearchBoxContainer, StyledI } from './SearchBox.styled';
import { useSelector } from 'react-redux';
import { logErrorToConsole } from 'src/utils/util';

const SearchBox = (props) => {
    const {
        updateSearch,
        searchProduct,
        width,
        paddingLeft,
        borderRadius,
        isSearchIcon,
        placeholder,
        margin,
        right,
        fontSize,
        iconColor,
        iconMarginLeft,
        iconMarginRight,
        iconPaddingLeft,
        borderLeft,
        marginTop,
        fontWeight,
        containerMobileWidth,
        searchIconWidth,
        handleKeyPress,
        onClick,
        onBlur,
        placeHolderFontFamily,
        height,
        paddingRight,
        background,
        enterkeyhint = 'none',
        borderColor,
        searchRef,
        marginDesktop,
        padding,
        opacity,
        autoComplete,
    } = props;
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    return (
        <SearchBoxContainer
            margin={margin}
            fontSize={fontSize}
            containerMobileWidth={containerMobileWidth}
            background={background}
            marginDesktop={!props.filterPage && isCondensedView ? '8px 8px' : marginDesktop}
        >
            <span
                style={{ width: '100%' }}
                className={
                    isSearchIcon
                        ? 'p-input-icon-left p-input-icon-right'
                        : 'p-input-icon-right'
                }
            >
                {isSearchIcon && (
                    <StyledI
                        style={{
                            color: iconColor ? iconColor : '#6c757d',
                            fontWeight: fontWeight ? fontWeight : 'normal',
                            width: searchIconWidth ? searchIconWidth : '',
                            left: iconMarginLeft ? iconMarginLeft : '0.5rem',
                            right: iconMarginRight ? iconMarginRight : '0.5rem',
                            borderLeft: borderLeft
                                ? borderLeft
                                : '1px solid #707070',
                            paddingLeft: iconPaddingLeft
                                ? iconPaddingLeft
                                : '5px',
                            paddingRight: paddingRight ? paddingRight : '10px',
                        }}
                    ></StyledI>
                )}
                {/* {isSearchIcon && <i className="pi pi-search" />} */}
                <InputText
                    style={{
                        width: width,
                        borderRadius: borderRadius,
                        paddingLeft: paddingLeft,
                        marginTop: marginTop,
                        fontSize: fontSize ? fontSize : '1rem',
                        fontFamily: placeHolderFontFamily
                            ? placeHolderFontFamily
                            : '',
                        boxShadow: 'none',
                        outline: 0,
                        WebkitAppearance: 'none',
                        borderColor: borderColor ? borderColor : '#ced4da',
                        height: height,
                        paddingRight: paddingRight,
                        padding: padding,
                        opacity: opacity,
                    }}
                    value={searchProduct}
                    onChange={(e) => updateSearch(e.target.value)}
                    placeholder={placeholder}
                    onKeyDown={(e) => {
                        handleKeyPress && handleKeyPress(e);
                    }}
                    enterkeyhint={enterkeyhint}
                    onClick={onClick}
                    onBlur={onBlur}
                    ref={searchRef}
                    autoComplete={autoComplete}
                />
                {searchProduct?.length > 0 && (
                    <i
                        className="pi pi-times"
                        style={{ cursor: 'pointer', right: `${right}` }}
                        onClick={() => {
                            try {
                            updateSearch('');
                            if (props?.clearSearch) {
                                props.clearSearch();
                            }
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
                )}
            </span>
        </SearchBoxContainer>
    );
};

export default SearchBox;
